import React from "react";
import { Link } from "react-router-dom";
import { Category } from "../types/ProductType";

type CategoryCardProps = {
  category: Category;
  className?: string;
};

export const CategoryCard: React.FC<CategoryCardProps> = ({
  category,
  className = "",
}) => {
  // Determine which image to use: banner_path > image_path > gradient
  const imageUrl = category.banner_path || category.image_path;

  return (
    <Link
      to={`/category/${category.slug}`}
      className={`group relative block overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ${className}`}
    >
      <div className="relative h-48 w-full overflow-hidden">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={category.name}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
            onError={(e) => {
              // Fallback to gradient if image fails to load
              const target = e.target as HTMLImageElement;
              target.style.display = "none";
              const parent = target.parentElement;
              if (parent) {
                const gradientDiv = parent.querySelector(".gradient-fallback");
                if (gradientDiv) {
                  (gradientDiv as HTMLElement).style.display = "flex";
                }
              }
            }}
          />
        ) : null}
        {/* Gradient fallback - shown by default if no image, or shown on image error */}
        <div
          className={`gradient-fallback h-full w-full bg-gradient-to-br from-emerald-300 via-green-400 to-emerald-500 flex items-center justify-center ${
            imageUrl ? "hidden" : "flex"
          }`}
        >
          <div className="text-center text-white">
            <div className="text-4xl font-bold mb-2">
              {category.name.charAt(0).toUpperCase()}
            </div>
            <div className="text-sm font-medium opacity-90">{category.name}</div>
          </div>
        </div>
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0"></div>
        {/* Category info */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-white font-bold text-lg group-hover:text-emerald-200 transition-colors">
            {category.name}
          </h3>
          {category.meta_description && (
            <p className="text-white/90 text-sm mt-1 line-clamp-2">
              {category.meta_description.length > 80
                ? `${category.meta_description.substring(0, 80)}...`
                : category.meta_description}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

